import { useMemo } from 'react';
import { useRecoilState } from 'recoil';
import { dashboardQueriesState, dashboardState, defaultQueryTemplateValuesState, isPublicViewState, isSharedState, } from '../../store/dashboardAtoms';

const useDashboardContext = () => {
  const [dashboard, setDashboard] = useRecoilState(dashboardState);
  const [dashboardQueries, setDashboardQueries] = useRecoilState(dashboardQueriesState);
  const [defaultQueryTemplateValues, setDefaultQueryTemplateValues] = useRecoilState(defaultQueryTemplateValuesState);
  const [isPublicView, setPublicView] = useRecoilState(isPublicViewState);
  const [isShared, setShared] = useRecoilState(isSharedState);

  const context = useMemo(() => ({
    dashboard,
    dashboardQueries,
    defaultQueryTemplateValues,
    isPublicView,
    isShared,
    setDashboard,
    setDashboardQueries,
    setDefaultQueryTemplateValues,
    setPublicView,
    setShared,
  }), [
    dashboard,
    dashboardQueries,
    defaultQueryTemplateValues,
    isPublicView,
    isShared,
    setDashboard,
    setDashboardQueries,
    setDefaultQueryTemplateValues,
    setPublicView,
    setShared,
  ]);

  return context;
};

export default useDashboardContext;